<template lang="pug">

div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    AppTitle(:title="$t('conferences')" tag="h2")
    p.u-text-lg.u-mb-mi {{ $t('conferencesDescription') }}
    .grid.is-desktop-4.is-tablet-6
      .column(v-for="({ node }) in upcomingEvents.edges" :key="node.id")
        AppCard(:img="node.thumb" :title="node.title" :date="node.startDate" :url="`/events/${node.slug}`" ratio="4:5")

  section.u-mt-md(v-if="meetups.edges.length")
    AppTitle(:title="$t('meetups')" tag="h2")
    p.u-text-lg.u-mb-mi {{ $t('meetupsDescription') }}
    .grid.is-tablet-6
      .column(v-for="({ node }) in meetups.edges" :key="node.id")
        AppCard(:img="node.thumb" :title="node.title" :date="node.startDate" :url="`/events/meetups/${node.slug}`" ratio="4:5")

  section.u-mt-md(v-if="pastEvents.edges.length")
    AppTitle.u-mb-mi(:title="$t('history')" tag="h2")
    .grid.is-tablet-6
      .column(v-for="({ node }) in pastEvents.edges" :key="node.id")
        AppCard(:img="node.thumb" :title="node.title" :date="node.startDate" :url="`/events/${node.slug}`" ratio="4:5")

  .u-mb-md
</template>

<script>
/*eslint-disable */
import { Events } from '~/graphql/Event.gql';

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },

  async asyncData({ app }) {
    const [upcomingEvents, pastEvents, meetups] = (
      await Promise.all([
        app.$api.query({
          query: Events,
          variables: {
            first: 5,
            filters: {
              scopes: ['MAIN'],
              time: 'upcoming',
              type: 'conference'
            }
          }
        }),
        app.$api.query({
          query: Events,
          variables: {
            first: 5,
            filters: {
              scopes: ['MAIN'],
              time: 'past',
              type: 'conference'
            }
          }
        }),
        app.$api.query({
          query: Events,
          variables: {
            first: 5,
            filters: {
              scopes: ['MAIN'],
              time: 'upcoming',
              type: 'meetup'
            }
          }
        })
      ])
    ).map(({ data }) => Object.freeze(data.events));

    return {
      upcomingEvents,
      pastEvents,
      meetups
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Events",
    "pageDesc": "Meet us on ground. Explore the events we organize, participate in and host then come join us in real life.",
    "mantra":"Sharing our exciting |journeys with you.",
    "history":"History of |past events",
    "conferences": "Conferences",
    "meetups": "Meetups",
    "conferencesDescription": "Discussions, insights, product launches and more! Join Baianat gatherings and get a closer look into our kitchen, what we do and how we do it.",
    "meetupsDescription": "Grab your ideal opportunity to meet and engage with like minded entrepreneurs who share your vision and ambition for building a remarkable startup in the digital world."
  },
  "ar": {
    "pageTitle":"فعاليات بيانات",
    "pageDesc": "تعرف على الفعاليات التي نقوم بتنظيمها وشارك فيها وانضم إلينا وتعرف على كل ما نقوم به واطرح ما تشاء من الأسئلة.",
    "mantra":"نتشارك معك أفكارنا |وخبراتنا وجهًا لوجه.",
    "history":"تاريخ الأحداث |السابقة",
    "conferences": "مؤتمرات",
    "meetups": "ملتقيات",
    "conferencesDescription": "نقاشات، رؤى، منتجات جديدة والمزيد! انضمم لمؤتمرات بيانات وادخل مطبخنا وتعرف على ما نقوم به وكيف نقوم به.",
    "meetupsDescription": "انتهز افضل فرصة للتفاعل ومقابلة اقرنائك الرياديين الذين يشاركونك رؤيتهم وطموحهم."
  }
}
</i18n>
